const formTestIdsScope = {
  FILE_UPLOAD_ZONE: 'file-upload-zone',
};

export const FormTestIds = {
  // ClaimsComponent
  CLAIMS_COMPONENT: 'claims.component',

  // FileUploadZone
  FILE_UPLOAD_ZONE_BROWSE_BUTTON: `${formTestIdsScope.FILE_UPLOAD_ZONE}.browse-button`,
  FILE_UPLOAD_ZONE_CLEAR_BUTTON: `${formTestIdsScope.FILE_UPLOAD_ZONE}.clear-button`,
  FILE_UPLOAD_ZONE_DELETE_BUTTON: `${formTestIdsScope.FILE_UPLOAD_ZONE}.delete-button`,
  FILE_UPLOAD_ZONE_DROPZONE: `${formTestIdsScope.FILE_UPLOAD_ZONE}.dropzone`,
  FILE_UPLOAD_ZONE_ERROR_ICON: `${formTestIdsScope.FILE_UPLOAD_ZONE}.error-icon`,
  FILE_UPLOAD_ZONE_ERROR_TEXT_LABEL: `${formTestIdsScope.FILE_UPLOAD_ZONE}.error-text-label`,
  FILE_UPLOAD_ZONE_FILE_INPUT: `${formTestIdsScope.FILE_UPLOAD_ZONE}.file-input`,
  FILE_UPLOAD_ZONE_SELECTED_FILE_CARD: `${formTestIdsScope.FILE_UPLOAD_ZONE}.selected-file-card`,
  FILE_UPLOAD_ZONE_SPINNER: `${formTestIdsScope.FILE_UPLOAD_ZONE}.spinner`,
  FILE_UPLOAD_ZONE_SUCCESS_ICON: `${formTestIdsScope.FILE_UPLOAD_ZONE}.success-icon`,
  FILE_UPLOAD_ZONE_UPLOAD_BUTTON: `${formTestIdsScope.FILE_UPLOAD_ZONE}.upload-button`,
  FILE_UPLOAD_ZONE_UPLOADED_FILE_CARD: `${formTestIdsScope.FILE_UPLOAD_ZONE}.uploaded-file-card`,

  // ColorPicker
  COLOR_PICKER_PLACEHOLDER_BUTTON: 'color-input.placeholder-button',
  COLOR_PICKER_CLEAR_BUTTON: 'color-input.clear-button',

  // ClaimsComponent
  CLAIMS_RADIO_GROUP: 'claims.radio-group',
  getClaimsCheckboxId: name => `claims.checkbox-${name}`,

  // Dynamic
  getCloseIconId: name => `close-icon.${name}`,
  getColorInputId: name => `color-input.${name}`,
};
